/* Fragrance Finder — MyCosmetics
   Motor client-side. Sursa de date e endpoint-ul propriu al temei
   (`/collections/<handle>?view=ff-json`), nu `products.json`: metafield-urile
   custom (familie olfactivă, caracter, recomandat pentru, parfum de referință)
   NU apar în products.json, iar pe ele stă tot finder-ul.

   Primul ecran e alegerea drumului, nu genul: cine știe că vrea „ceva ca
   Sauvage" nu trebuie să declare întâi pentru cine caută. Genul rămâne ca drum
   propriu (7) și ca filtru pe ecranul de rezultate.

   Șapte drumuri către rezultat, în ordinea din brief:
     1. ref       — „Caută după parfumul preferat" (autocomplete pe parfumul de referință)
     2. quiz      — „Nu știi ce parfum să alegi?" (3 întrebări)
     3. caracter  — carduri: Fresh, Dulce, Elegant...        (metafield stil_parfum)
     4. familie   — carduri: Citrice, Floral, Lemnos...      (metafield familie_olfactiva)
     5. aroma     — autocomplete pe note                     (note_de_* / aroma)
     6. utilizare — carduri: Zi, Seara, Vara, Iarna...       (metafield utilizare)
     7. gen       — carduri: Femei, Bărbați, Unisex          (colecțiile de gen)

   Drumurile 3, 4, 6 și 7 sunt același ecran generic, parametrizat pe axă; se
   adaugă unul nou cu o singură intrare în AXES. */
(function () {
  'use strict';

  var CACHE_TTL = 60 * 60 * 1000; // 1h
  var NOTE_RE = /Note\s+de\s+(v[âa]rf|mijloc|inim[ăa]|baz[ăa])\s*:?\s*(?:<\/strong>)?\s*:?\s*([^<]+)/gi;

  var SYNONYMS = {
    'paciuli': 'patchouli',
    'boabe de tonka': 'fava tonka',
    'bob tonka': 'fava tonka',
    'tonka': 'fava tonka',
    'lamaie de sicilia': 'lamaie',
    'lamaie verde': 'lime',
    'santal': 'lemn de santal',
    'lemn de santal alb': 'lemn de santal',
    'cedru': 'lemn de cedru',
    'chihlimbar': 'ambra',
    'flori de portocal': 'floare de portocal',
    'flori de portocala': 'floare de portocal',
    'portocale rosii': 'portocala rosie',
    'iasomie sambac': 'iasomie',
    'mosc cristalin': 'mosc alb',
    'note marine': 'note acvatice',
    'acvatic': 'note acvatice',
    'sarea marii': 'sare de mare'
  };

  /* Emoji pentru valorile cunoscute ale metafield-urilor. Cheia e valoarea
     normalizată; ce nu e în listă primește un emoji neutru, deci o valoare nouă
     adăugată în admin apare oricum, nu dispare. */
  var VALUE_EMOJI = {
    // caracter (custom.stil_parfum)
    'fresh': '☀️', 'dulce': '🍬', 'elegant': '✨', 'senzual': '❤️', 'misterios': '🖤',
    'luxos': '💎', 'intens': '🔥', 'curat': '🧼', 'romantic': '🌹', 'casual': '👕',
    // familie olfactivă (custom.familie_olfactiva)
    'acvatic': '🌊', 'citrice': '🍋', 'floral': '🌹', 'lemnos': '🌳', 'gourmand': '🍮',
    'verde': '🌿', 'chypre': '🪵', 'condimentat': '🌶️', 'ambrat / oriental': '🕌',
    'aromatic': '🌱', 'balsamic': '🕯️', 'fougere': '🍃', 'fructat': '🍑',
    'pudrat': '🤍', 'aldehidic': '🫧',
    // recomandat pentru (custom.utilizare)
    'zi': '☀️', 'seara': '🌙', 'noapte': '🌃', 'primavara': '🌸', 'vara': '🌞',
    'toamna': '🍂', 'iarna': '❄️'
  };

  /* Axele „alege din carduri". Ordinea valorilor e cea din brief: pe ecran
     apar în ordinea asta, nu alfabetic, ca lista să se citească natural. */
  var AXES = {
    caracter: { field: 'stil', order: ['fresh', 'dulce', 'elegant', 'senzual', 'misterios', 'luxos', 'intens', 'curat', 'romantic', 'casual'] },
    familie: { field: 'fams', order: ['acvatic', 'citrice', 'floral', 'lemnos', 'gourmand', 'verde', 'chypre', 'condimentat'] },
    utilizare: { field: 'util', order: ['zi', 'seara', 'noapte', 'primavara', 'vara', 'toamna', 'iarna'] },
    /* Genul e tot o axă, nu un pas obligatoriu: cine știe că vrea „ceva ca
       Sauvage" nu trebuie să declare întâi pentru cine caută. Valorile vin din
       blocurile „Destinatar", nu dintr-o listă fixă. */
    gen: { field: 'gens', order: [], fromGenders: true }
  };

  function stripDiacritics(s) {
    return s.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ș|ş/g, 's').replace(/ț|ţ/g, 't');
  }
  function noteKey(raw) {
    var k = stripDiacritics(String(raw).toLowerCase()).replace(/[^a-z0-9\s-]/g, ' ').replace(/\s+/g, ' ').trim();
    return SYNONYMS[k] || k;
  }
  /* Cheie pentru valorile de metafield: spre deosebire de note, aici păstrăm
     „/" din „Ambrat / Oriental", altfel două familii diferite s-ar putea ciocni. */
  function valKey(raw) {
    return stripDiacritics(String(raw).toLowerCase()).replace(/\s+/g, ' ').trim();
  }
  function titleCase(s) {
    return s.replace(/\S+/g, function (w) {
      return w.length > 2 || w === 'de' ? w.charAt(0).toUpperCase() + w.slice(1) : w;
    }).replace(/ De /g, ' de ').replace(/ Din /g, ' din ');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(v) {
    return (Math.round(v * 100) / 100).toLocaleString('ro-RO', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' lei';
  }
  function pyramidSlot(label) {
    label = stripDiacritics(label.toLowerCase());
    if (label.indexOf('varf') !== -1) return 'top';
    if (label.indexOf('baz') !== -1) return 'base';
    return 'heart';
  }
  function uniq(arr) {
    return arr.filter(function (x, i, a) { return x && a.indexOf(x) === i; });
  }

  /* Dicționare de afișare: cheie normalizată -> cum se scrie pentru om.
     Se completează pe măsură ce citim catalogul, ca să nu inventăm noi
     diacriticele înapoi. */
  var display = { note: {}, val: {}, ref: {} };
  function remember(bucket, key, raw) {
    var d = String(raw).trim();
    if (!d) return;
    if (!display[bucket][key] || d.length < display[bucket][key].length) display[bucket][key] = d;
  }
  function noteLabel(k) { return display.note[k] || titleCase(k); }
  function valLabel(k) { return display.val[k] || titleCase(k); }

  /* ---------- catalog ---------- */

  /* Plasă de siguranță pentru produsele fără note în metafield-uri: descrierea
     ajunge în JSON doar dacă are piramida olfactivă (vezi ff-product-json). */
  function parseNotes(bodyHtml) {
    var notes = { top: [], heart: [], base: [] };
    var found = false;
    var m;
    NOTE_RE.lastIndex = 0;
    var text = String(bodyHtml || '');
    while ((m = NOTE_RE.exec(text)) !== null) {
      var slot = pyramidSlot(m[1]);
      m[2].split(/[,;]|\si\s/).forEach(function (part) {
        var raw = part.replace(/&nbsp;/g, ' ').trim().replace(/[.:]+$/, '').trim();
        if (!raw || raw.length > 42) return;
        var key = noteKey(raw);
        if (!key || key.length < 3) return;
        if (notes[slot].indexOf(key) === -1) notes[slot].push(key);
        found = true;
        remember('note', key, titleCase(raw.toLowerCase()));
      });
    }
    return found ? notes : null;
  }

  function mfNotes(list) {
    return uniq((list || []).map(function (raw) {
      var k = noteKey(raw);
      if (k) remember('note', k, String(raw).trim());
      return k;
    }));
  }
  function mfVals(list) {
    return uniq((list || []).map(function (raw) {
      var k = valKey(raw);
      if (k) remember('val', k, String(raw).trim());
      return k;
    }));
  }

  function normalizeProduct(p) {
    if (!p || !p.handle) return null;
    /* Gelurile de duș, loțiunile și seturile de îngrijire stau în colecțiile de
       parfumuri, dar nu sunt parfumuri — filtrul e în ff-product-json. */
    if (p.este_parfum === false) return null;
    var price = parseFloat(p.price);
    if (!isFinite(price)) return null;
    var mf = p.mf || {};

    var notes = { top: mfNotes(mf.note_de_varf), heart: mfNotes(mf.note_de_mijloc), base: mfNotes(mf.note_de_baza) };
    var hasNotes = notes.top.length + notes.heart.length + notes.base.length > 0;
    if (!hasNotes) {
      var parsed = parseNotes(p.body);
      if (parsed) { notes = parsed; hasNotes = true; }
    }
    /* `aroma` e lista curatată de note, fără poziție în piramidă: o folosim ca
       ultimă sursă și o adăugăm oricum la căutare. */
    var aroma = mfNotes(mf.aroma);
    if (!hasNotes && aroma.length) { notes.heart = aroma; hasNotes = true; }

    var refs = uniq((mf.parfum_de_referinta || []).map(function (raw) {
      var k = valKey(raw);
      if (k) remember('ref', k, String(raw).trim());
      return k;
    }));
    var brands = uniq((mf.brand_de_referinta || []).map(function (raw) {
      var k = valKey(raw);
      if (k) remember('ref', k, String(raw).trim());
      return k;
    }));

    return {
      id: p.id,
      handle: p.handle,
      title: p.title,
      vendor: p.vendor || '',
      url: p.url || ('/products/' + p.handle),
      price: price,
      image: p.image || '',
      available: p.available !== false,
      notes: hasNotes ? notes : null,
      all: uniq(notes.top.concat(notes.heart, notes.base, aroma)),
      fams: mfVals(mf.familie_olfactiva),
      /* Caracterul și „recomandat pentru" vin gata rezolvate din ff-derive:
         metafield dacă există, altfel dedus din familia olfactivă. */
      stil: mfVals(p.stil_parfum),
      util: mfVals(p.utilizare),
      refs: refs,
      brands: brands
    };
  }

  function fetchCatalog(handle) {
    var cacheKey = 'ff:v3:' + handle;
    try {
      var cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if (cached && Date.now() - cached.t < CACHE_TTL) {
        ['note', 'val', 'ref'].forEach(function (b) { display[b] = Object.assign(display[b], (cached.display || {})[b] || {}); });
        return Promise.resolve(cached.items);
      }
    } catch (e) { /* cache corupt — ignorăm */ }

    function page(n) {
      return fetch('/collections/' + handle + '?view=ff-json&page=' + n)
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); });
    }

    /* Prima pagină spune câte sunt; restul pleacă în paralel. Secvențial ar fi
       însemnat 6 dus-întorsuri înainte de primul ecran. */
    return page(1).then(function (first) {
      var pages = Math.min(parseInt(first.pages, 10) || 1, 12);
      var rest = [];
      for (var n = 2; n <= pages; n++) rest.push(page(n));
      return Promise.all(rest).then(function (list) { return [first].concat(list); });
    }).then(function (chunks) {
      var items = [];
      chunks.forEach(function (d) {
        (d.products || []).forEach(function (raw) {
          var p = normalizeProduct(raw);
          if (p) items.push(p);
        });
      });
      try {
        sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), items: items, display: display }));
      } catch (e) { /* quota — mergem fără cache */ }
      return items;
    });
  }

  /* ---------- quiz (fallback dacă nu există blocks în Theme Editor) ---------- */

  var VIBE_QUESTIONS = [
    {
      key: 'caracter', q: 'Ce preferi?', axis: 'stil', options: [
        { key: 'fresh', label: 'Fresh', emoji: '☀️', value: 'fresh' },
        { key: 'dulce', label: 'Dulce', emoji: '🍬', value: 'dulce' },
        { key: 'elegant', label: 'Elegant', emoji: '✨', value: 'elegant' },
        { key: 'intens', label: 'Intens', emoji: '🔥', value: 'intens' }
      ]
    },
    {
      key: 'moment', q: 'Pentru când?', axis: 'util', options: [
        { key: 'zi', label: 'Zi', emoji: '☀️', value: 'zi' },
        { key: 'seara', label: 'Seara', emoji: '🌙', value: 'seara' },
        { key: 'vara', label: 'Vara', emoji: '🌞', value: 'vara' },
        { key: 'iarna', label: 'Iarna', emoji: '❄️', value: 'iarna' }
      ]
    },
    {
      key: 'aroma', q: 'Îți plac aromele?', axis: 'nota', options: [
        { key: 'vanilie', label: 'Vanilie', emoji: '🍮', value: 'vanilie' },
        { key: 'citrice', label: 'Citrice', emoji: '🍋', value: 'citrice' },
        { key: 'trandafir', label: 'Trandafir', emoji: '🌹', value: 'trandafir' },
        { key: 'oud', label: 'Oud', emoji: '🪵', value: 'oud' },
        { key: 'cafea', label: 'Cafea', emoji: '☕', value: 'cafea' }
      ]
    }
  ];

  /* ---------- componenta ---------- */

  function FragranceFinder(root) {
    this.root = root;
    var cfgEl = root.querySelector('[data-ff-config]');
    this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : { genders: [], families: [], modes: [] };
    this.catalog = [];
    this.stage = root.querySelector('[data-ff-stage]');
    this.progress = root.querySelector('[data-ff-progress]');
    this.toastEl = root.querySelector('[data-ff-toast]');
    this.maxNotes = parseInt(this.cfg.maxNotes, 10) || 4;
    this.maxVals = parseInt(this.cfg.maxVals, 10) || 3;

    var quiz = (this.cfg.quiz && this.cfg.quiz.length) ? this.cfg.quiz : VIBE_QUESTIONS;
    this.quiz = quiz.map(function (q) {
      return {
        key: q.key,
        q: q.q,
        axis: q.axis || 'stil',
        options: (q.options || []).map(function (o) {
          return { key: o.key, label: o.label, emoji: o.emoji || '', value: valKey(o.value || o.label) };
        }).filter(function (o) { return o.label; })
      };
    }).filter(function (q) { return q.q && q.options.length >= 2; });

    this.restoreFromUrl();
    var self = this;
    window.addEventListener('popstate', function () { self.restoreFromUrl(); });
  }

  var P = FragranceFinder.prototype;

  P.track = function (event, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'ff_' + event }, data || {})); } catch (e) {}
  };

  P.toast = function (msg) {
    var el = this.toastEl;
    if (!el) return;
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(this._toastT);
    this._toastT = setTimeout(function () { el.classList.remove('show'); }, 2400);
  };

  /* ----- URL & profil salvat ----- */

  P.syncUrl = function (replace) {
    var p = new URLSearchParams();
    var s = this.state;
    if (s.gen) p.set('gen', s.gen);
    if (s.mode) p.set('mod', s.mode);
    if (s.notes.length) p.set('note', s.notes.join(','));
    if (s.vals.length) p.set('val', s.vals.join(','));
    if (s.ref) p.set('ref', s.ref);
    var vibeKeys = Object.keys(s.vibe);
    if (vibeKeys.length) p.set('vibe', vibeKeys.map(function (k) { return k + ':' + s.vibe[k]; }).join(','));
    if (s.priceMin != null) p.set('min', s.priceMin);
    if (s.priceMax != null) p.set('max', s.priceMax);
    var url = location.pathname + (p.toString() ? '?' + p.toString() : '');
    history[replace ? 'replaceState' : 'pushState']({ ff: 1 }, '', url);
  };

  P.restoreFromUrl = function () {
    var p = new URLSearchParams(location.search);
    this.state = {
      gen: p.get('gen'),
      mode: p.get('mod'),
      notes: (p.get('note') || '').split(',').filter(Boolean),
      vals: (p.get('val') || '').split(',').filter(Boolean),
      ref: p.get('ref') || null,
      vibe: {},
      priceMin: p.get('min') != null ? parseFloat(p.get('min')) : null,
      priceMax: p.get('max') != null ? parseFloat(p.get('max')) : null
    };
    var self = this;
    (p.get('vibe') || '').split(',').filter(Boolean).forEach(function (pair) {
      var kv = pair.split(':');
      if (kv.length === 2) self.state.vibe[kv[0]] = kv[1];
    });
    this.route();
  };

  P.saveProfile = function (profile) {
    try { localStorage.setItem('ff:profil', JSON.stringify({ t: Date.now(), profile: profile, url: location.search })); } catch (e) {}
  };
  P.savedProfile = function () {
    try { return JSON.parse(localStorage.getItem('ff:profil') || 'null'); } catch (e) { return null; }
  };

  /* ----- routing ----- */

  P.route = function () {
    var s = this.state;
    if (!s.mode) return this.renderMode();
    var self = this;
    this.ensureCatalog().then(function () {
      if (self.isReady()) return self.renderResults();
      if (s.mode === 'ref') return self.renderRefStep();
      if (s.mode === 'quiz') return self.renderQuizStep();
      if (s.mode === 'aroma') return self.renderAromaStep();
      if (AXES[s.mode]) return self.renderAxisStep(s.mode);
      self.renderMode();
    });
  };

  P.isReady = function () {
    var s = this.state;
    if (s.mode === 'ref') return !!s.ref;
    if (s.mode === 'quiz') return this.quiz.length > 0 && Object.keys(s.vibe).length === this.quiz.length;
    if (s.mode === 'aroma') return s.notes.length > 0;
    if (AXES[s.mode]) return s.vals.length > 0;
    return false;
  };

  P.setProgress = function (step, labels) {
    var html = labels.map(function (l, i) {
      var cls = i + 1 === step ? ' is-active' : (i + 1 < step ? ' is-done' : '');
      return '<span class="ff__progress-pill' + cls + '"><i>' + (i + 1 < step ? '✓' : i + 1) + '</i>' + esc(l) + '</span>';
    }).join('');
    this.progress.innerHTML = html;
  };

  P.genderOf = function (key) {
    return (this.cfg.genders || []).filter(function (g) { return g.key === key; })[0] || null;
  };

  /* Catalogul acoperă toate genurile deodată: genul nu mai e primul pas, deci
     nu mai putem ști dinainte din ce colecție să citim. Colecțiile se descarcă
     în paralel și se unesc după handle — un parfum unisex apare în mai multe
     colecții, dar rămâne un singur produs, cu toate genurile lui în `gens`. */
  P.ensureCatalog = function () {
    var gens = (this.cfg.genders || []).filter(function (g) { return g.collection; });
    if (!gens.length) return Promise.resolve([]);
    var sig = gens.map(function (g) { return g.collection; }).join('|');
    if (this._catalogFor === sig && this.catalog.length) return Promise.resolve(this.catalog);
    var self = this;
    this.stage.innerHTML = '<div class="ff__loading">' + esc(this.cfg.texts.loading) +
      '<div><span class="dot"></span><span class="dot"></span><span class="dot"></span></div></div>';
    return Promise.all(gens.map(function (g) {
      return fetchCatalog(g.collection).then(function (items) { return { gen: g.key, items: items }; });
    })).then(function (chunks) {
      var byHandle = {};
      var order = [];
      chunks.forEach(function (c) {
        c.items.forEach(function (p) {
          var seen = byHandle[p.handle];
          if (seen) {
            if (seen.gens.indexOf(c.gen) === -1) seen.gens.push(c.gen);
            return;
          }
          p.gens = [c.gen];
          byHandle[p.handle] = p;
          order.push(p);
        });
      });
      self.catalog = order;
      self._catalogFor = sig;
      return order;
    }).catch(function () {
      self.stage.innerHTML = '<div class="ff__empty">' + esc(self.cfg.texts.error) + '</div>';
      return [];
    });
  };

  /* ----- numărători ----- */

  P.noteCounts = function () {
    var counts = {};
    this.catalog.forEach(function (p) {
      p.all.forEach(function (n) { counts[n] = (counts[n] || 0) + 1; });
    });
    return counts;
  };

  P.axisCounts = function (mode) {
    var field = AXES[mode].field;
    var counts = {};
    this.catalog.forEach(function (p) {
      (p[field] || []).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
    });
    return counts;
  };

  /* Referințele („Dior Sauvage") cu numărul de parfumuri inspirate de ele. */
  P.refIndex = function () {
    if (this._refIndex && this._refIndexFor === this._catalogFor) return this._refIndex;
    var map = {};
    this.catalog.forEach(function (p) {
      p.refs.forEach(function (r) {
        if (!map[r]) map[r] = { key: r, label: display.ref[r] || titleCase(r), n: 0, brand: p.brands[0] || '' };
        map[r].n++;
      });
    });
    var list = Object.keys(map).map(function (k) { return map[k]; })
      .sort(function (a, b) { return a.label.localeCompare(b.label, 'ro'); });
    this._refIndex = list;
    this._refIndexFor = this._catalogFor;
    return list;
  };

  /* ----- etichete pe axă ----- */

  P.axisLabel = function (mode, key) {
    if (AXES[mode] && AXES[mode].fromGenders) {
      var g = this.genderOf(key);
      return g ? g.label : titleCase(key);
    }
    return valLabel(key);
  };
  P.axisEmoji = function (mode, key) {
    if (AXES[mode] && AXES[mode].fromGenders) {
      var g = this.genderOf(key);
      return (g && g.emoji) || '✨';
    }
    return VALUE_EMOJI[key] || '✨';
  };

  /* ----- pas 1: drumul ales ----- */

  P.renderMode = function () {
    this.setProgress(1, this.cfg.stepLabels);
    var t = this.cfg.texts;
    var saved = this.savedProfile();
    var welcome = '';
    if (saved && saved.profile && saved.profile.headline) {
      welcome = '<div class="ff__welcome"><span>👋 Bine ai revenit! Data trecută: <b>' + esc(saved.profile.headline) + '</b></span>' +
        '<button class="ff__btn ff__btn--ghost" data-ff="resume">Vezi din nou rezultatele</button></div>';
    }
    var modes = (this.cfg.modes || []).filter(function (m) { return m.enabled !== false && m.label; });
    var cards = modes.map(function (m, i) {
      /* Primul drum e cel recomandat: card mai mare, pe două coloane, ca să nu
         se piardă într-o listă de șapte opțiuni egale. */
      var star = i === 0 ? ' ff__card--star' : '';
      return '<button type="button" class="ff__card' + star + '" data-ff="mode" data-key="' + esc(m.key) + '">' +
        '<span class="ff__card-body"><span class="ff__mode-ico">' + (m.emoji || '✨') + '</span>' +
        '<span class="ff__card-label">' + esc(m.label) + '</span>' +
        (m.hint ? '<span class="ff__card-hint">' + esc(m.hint) + '</span>' : '') + '</span></button>';
    }).join('');
    this.stage.innerHTML = welcome +
      '<div class="ff__step"><div class="ff__kicker">' + esc(t.kicker) + '</div>' +
      '<h2 class="ff__title">' + esc(t.step2Title) + '</h2>' +
      '<p class="ff__sub">' + esc(t.step2Sub) + '</p>' +
      '<div class="ff__cards ff__cards--modes">' + cards + '</div></div>';
    this.bind();
  };

  /* ----- drumul 1: parfumul preferat ----- */

  P.renderRefStep = function () {
    this.setProgress(2, this.cfg.stepLabels);
    var t = this.cfg.texts;
    var total = this.refIndex().length;
    if (!total) {
      /* Fără metafield-ul `parfum_de_referinta` completat, ecranul ar fi o
         căutare care nu găsește niciodată nimic. */
      this.stage.innerHTML =
        '<div class="ff__step"><h2 class="ff__title">' + esc(t.refTitle) + '</h2>' +
        '<div class="ff__empty"><p>' + esc(t.refNone) + '</p>' +
        '<button class="ff__btn ff__btn--primary" data-ff="back-mode">' + esc(t.back) + '</button></div></div>';
      this.bind();
      return;
    }
    this.stage.innerHTML =
      '<div class="ff__step"><div class="ff__kicker">' + esc(t.kicker) + '</div>' +
      '<h2 class="ff__title">' + esc(t.refTitle) + '</h2>' +
      '<p class="ff__sub">' + esc(t.refSub) + '</p>' +
      '<div class="ff__ac">' +
      '<div class="ff__search">🔎 <input type="text" autocomplete="off" placeholder="' + esc(t.refPlaceholder) + '" data-ff="ref-search"></div>' +
      '<div class="ff__ac-list" data-ff-ac hidden></div></div>' +
      '<p class="ff__ac-hint">' + esc(t.refExamples) + '</p>' +
      '<div class="ff__nav"><button class="ff__btn ff__btn--ghost" data-ff="back-mode">' + esc(t.back) + '</button></div></div>';
    this.bind();
    var input = this.stage.querySelector('[data-ff="ref-search"]');
    if (input) input.focus();
  };

  /* Sugestiile apar pe măsură ce omul scrie; sub 2 caractere lista ar fi
     practic tot catalogul, deci nu o deschidem. */
  P.refSuggest = function (q) {
    var box = this.stage.querySelector('[data-ff-ac]');
    if (!box) return;
    var needle = stripDiacritics(String(q).toLowerCase().trim());
    if (needle.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
    var hits = this.refIndex().filter(function (r) {
      return stripDiacritics(r.label.toLowerCase()).indexOf(needle) !== -1;
    }).slice(0, 8);
    if (!hits.length) {
      box.innerHTML = '<div class="ff__ac-empty">' + esc(this.cfg.texts.refNoHit) + '</div>';
      box.hidden = false;
      return;
    }
    box.innerHTML = hits.map(function (r) {
      return '<button type="button" class="ff__ac-item" data-ff="ref-pick" data-key="' + esc(r.key) + '">' +
        '<span class="ff__ac-name">' + esc(r.label) + '</span>' +
        '<span class="ff__ac-n">' + r.n + '</span></button>';
    }).join('');
    box.hidden = false;
    this.bind(box);
  };

  /* ----- drumul 5: arome (autocomplete, nu 250 de chips) ----- */

  P.renderAromaStep = function () {
    this.setProgress(2, this.cfg.stepLabels);
    var t = this.cfg.texts;
    this.stage.innerHTML =
      '<div class="ff__step"><div class="ff__kicker">' + esc(t.kicker) + '</div>' +
      '<h2 class="ff__title">' + esc(t.aromaTitle).replace('{max}', this.maxNotes) + '</h2>' +
      '<p class="ff__sub">' + esc(t.aromaSub).replace('{max}', this.maxNotes) + '</p>' +
      '<div class="ff__ac">' +
      '<div class="ff__search">🔎 <input type="text" autocomplete="off" placeholder="' + esc(t.searchNote) + '" data-ff="note-search"></div>' +
      '<div class="ff__ac-list" data-ff-ac hidden></div></div>' +
      '<p class="ff__ac-hint">' + esc(t.aromaExamples) + '</p>' +
      '<div class="ff__bar"><div class="ff__bar-sel" data-ff-selbar></div>' +
      '<div style="display:flex;gap:10px;align-items:center;flex-wrap:wrap">' +
      '<button class="ff__btn ff__btn--link" data-ff="surprise">' + esc(t.surprise) + '</button>' +
      '<button class="ff__btn ff__btn--ghost" data-ff="back-mode">' + esc(t.back) + '</button>' +
      '<button class="ff__btn ff__btn--primary" data-ff="go-results" ' + (this.state.notes.length ? '' : 'disabled') + '>' + esc(t.getResults) + '</button>' +
      '</div></div></div>';
    this.bind();
    this.refreshSelBar();
  };

  P.noteSuggest = function (q) {
    var box = this.stage.querySelector('[data-ff-ac]');
    if (!box) return;
    var needle = stripDiacritics(String(q).toLowerCase().trim());
    if (needle.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
    var counts = this.noteCounts();
    var self = this;
    var hits = Object.keys(counts)
      .filter(function (n) { return n.indexOf(needle) !== -1 && self.state.notes.indexOf(n) === -1; })
      .sort(function (a, b) {
        /* Potrivirile de la începutul cuvântului primele: cine scrie „van" vrea
           „Vanilie", nu „Lemn de guaiac cu vanilie". */
        var pa = a.indexOf(needle) === 0 ? 0 : 1;
        var pb = b.indexOf(needle) === 0 ? 0 : 1;
        return pa - pb || counts[b] - counts[a];
      })
      .slice(0, 8);
    if (!hits.length) {
      box.innerHTML = '<div class="ff__ac-empty">' + esc(this.cfg.texts.aromaNoHit) + '</div>';
      box.hidden = false;
      return;
    }
    box.innerHTML = hits.map(function (n) {
      return '<button type="button" class="ff__ac-item" data-ff="note-pick" data-key="' + esc(n) + '">' +
        '<span class="ff__ac-name">' + esc(noteLabel(n)) + '</span>' +
        '<span class="ff__ac-n">' + counts[n] + '</span></button>';
    }).join('');
    box.hidden = false;
    this.bind(box);
  };

  P.refreshSelBar = function () {
    var bar = this.stage.querySelector('[data-ff-selbar]');
    if (!bar) return;
    var self = this;
    if (!this.state.notes.length) {
      bar.innerHTML = '<span style="color:#a49d95">' + esc(this.cfg.texts.noSelection) + '</span>';
    } else {
      bar.innerHTML = this.state.notes.map(function (n) {
        return '<span class="tag">' + esc(noteLabel(n)) +
          '<button type="button" data-ff="unnote" data-key="' + esc(n) + '">✕</button></span>';
      }).join('');
    }
    var go = this.stage.querySelector('[data-ff="go-results"]');
    if (go) go.disabled = !this.state.notes.length;
    bar.querySelectorAll('[data-ff="unnote"]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.state.notes = self.state.notes.filter(function (x) { return x !== b.dataset.key; });
        self.refreshSelBar();
      });
    });
  };

  /* ----- drumurile 3, 4, 6: carduri pe o axă ----- */

  P.renderAxisStep = function (mode) {
    this.setProgress(2, this.cfg.stepLabels);
    var t = this.cfg.texts;
    var axis = AXES[mode];
    var counts = this.axisCounts(mode);
    var self = this;
    /* Întâi valorile din ordinea din brief (la gen: ordinea blocurilor din
       Theme Editor), apoi orice valoare nouă apărută în admin. Ce nu are niciun
       produs nu se afișează. */
    var order = axis.fromGenders ? (this.cfg.genders || []).map(function (g) { return g.key; }) : axis.order;
    var keys = order.filter(function (k) { return counts[k]; })
      .concat(Object.keys(counts).filter(function (k) { return order.indexOf(k) === -1; })
        .sort(function (a, b) { return counts[b] - counts[a]; }));

    if (!keys.length) {
      this.stage.innerHTML =
        '<div class="ff__step"><h2 class="ff__title">' + esc(t['title_' + mode] || t.resultsTitle) + '</h2>' +
        '<div class="ff__empty"><p>' + esc(t.axisNone) + '</p>' +
        '<button class="ff__btn ff__btn--primary" data-ff="back-mode">' + esc(t.back) + '</button></div></div>';
      this.bind();
      return;
    }

    var cards = keys.map(function (k) {
      var sel = self.state.vals.indexOf(k) !== -1 ? ' is-selected' : '';
      return '<button type="button" class="ff__card ff__card--attr' + sel + '" data-ff="val" data-key="' + esc(k) + '">' +
        '<span class="ff__card-body"><span class="ff__mode-ico">' + self.axisEmoji(mode, k) + '</span>' +
        '<span class="ff__card-label">' + esc(self.axisLabel(mode, k)) + '</span>' +
        '<span class="ff__card-hint">' + counts[k] + ' ' + esc(t.perfumes) + '</span></span></button>';
    }).join('');

    this.stage.innerHTML =
      '<div class="ff__step"><div class="ff__kicker">' + esc(t.kicker) + '</div>' +
      '<h2 class="ff__title">' + esc(t['title_' + mode] || '') + '</h2>' +
      '<p class="ff__sub">' + esc(t.axisSub).replace('{max}', this.maxVals) + '</p>' +
      '<div class="ff__cards ff__cards--attr">' + cards + '</div>' +
      '<div class="ff__bar"><div class="ff__bar-sel" data-ff-valbar></div>' +
      '<div style="display:flex;gap:10px;flex-wrap:wrap">' +
      '<button class="ff__btn ff__btn--ghost" data-ff="back-mode">' + esc(t.back) + '</button>' +
      '<button class="ff__btn ff__btn--primary" data-ff="go-results" ' + (this.state.vals.length ? '' : 'disabled') + '>' + esc(t.getResults) + '</button>' +
      '</div></div></div>';
    this.bind();
    this.refreshValBar();
  };

  P.refreshValBar = function () {
    var bar = this.stage.querySelector('[data-ff-valbar]');
    if (!bar) return;
    var self = this;
    if (!this.state.vals.length) {
      bar.innerHTML = '<span style="color:#a49d95">' + esc(this.cfg.texts.axisEmpty) + '</span>';
    } else {
      var mode = this.state.mode;
      bar.innerHTML = this.state.vals.map(function (v) {
        return '<span class="tag">' + esc(self.axisLabel(mode, v)) +
          '<button type="button" data-ff="unval" data-key="' + esc(v) + '">✕</button></span>';
      }).join('');
    }
    var go = this.stage.querySelector('[data-ff="go-results"]');
    if (go) go.disabled = !this.state.vals.length;
    bar.querySelectorAll('[data-ff="unval"]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.state.vals = self.state.vals.filter(function (x) { return x !== b.dataset.key; });
        var card = self.stage.querySelector('.ff__card--attr[data-key="' + CSS.escape(b.dataset.key) + '"]');
        if (card) card.classList.remove('is-selected');
        self.refreshValBar();
      });
    });
  };

  /* ----- drumul 2: mini chestionar ----- */

  P.renderQuizStep = function () {
    this.setProgress(2, this.cfg.stepLabels);
    var t = this.cfg.texts;
    var answered = Object.keys(this.state.vibe).length;
    var q = this.quiz[answered];
    if (!q) return this.renderMode();
    var cards = q.options.map(function (o) {
      return '<button type="button" class="ff__card" data-ff="vibe" data-q="' + esc(q.key) + '" data-key="' + esc(o.key) + '">' +
        '<span class="ff__card-body"><span class="ff__mode-ico">' + (o.emoji || '✨') + '</span>' +
        '<span class="ff__card-label">' + esc(o.label) + '</span></span></button>';
    }).join('');
    this.stage.innerHTML =
      '<div class="ff__step"><div class="ff__kicker">' + esc(t.quizKicker) + ' · ' + (answered + 1) + '/' + this.quiz.length + '</div>' +
      '<h2 class="ff__title">' + esc(q.q) + '</h2>' +
      '<div class="ff__cards ff__cards--attr">' + cards + '</div>' +
      '<div class="ff__nav"><button class="ff__btn ff__btn--ghost" data-ff="back-quiz">' + esc(t.back) + '</button></div></div>';
    this.bind();
  };

  /* Răspunsurile quiz-ului, grupate pe axa fiecărei întrebări. */
  P.quizPicks = function () {
    var s = this.state;
    var out = { stil: [], util: [], fams: [], nota: [] };
    this.quiz.forEach(function (q) {
      var chosen = q.options.filter(function (o) { return o.key === s.vibe[q.key]; })[0];
      if (!chosen) return;
      var bucket = out[q.axis] ? q.axis : 'stil';
      if (out[bucket].indexOf(chosen.value) === -1) out[bucket].push(chosen.value);
    });
    return out;
  };

  /* ----- scoring ----- */

  P.computeMatches = function () {
    var s = this.state;
    var self = this;
    var scored = [];
    var picks = [];
    /* Genul e filtru, nu pas: rămâne aplicat peste orice drum, ca cineva care a
       ales „Fresh" să nu primească parfumuri de damă dacă a spus că vrea bărbat.
       Fără el, toate genurile intră în rezultate. */
    var pool = this.catalog.filter(function (p) {
      if (!p.available) return false;
      if (s.gen && (p.gens || []).indexOf(s.gen) === -1) return false;
      return true;
    });

    if (s.mode === 'ref') {
      var key = s.ref;
      picks = [display.ref[key] || titleCase(key)];
      scored = pool.map(function (p) {
        /* Potrivirea exactă pe parfumul de referință e singura care contează cu
           adevărat; același brand e doar plasă de siguranță, ca lista să nu
           rămână de trei produse. */
        if (p.refs.indexOf(key) !== -1) return { p: p, matched: picks.slice(), score: 10 };
        if (p.brands.indexOf(key) !== -1) return { p: p, matched: picks.slice(), score: 4 };
        return null;
      }).filter(Boolean);
    } else if (s.mode === 'aroma') {
      picks = s.notes.map(noteLabel);
      scored = pool.map(function (p) {
        var matched = s.notes.filter(function (n) { return p.all.indexOf(n) !== -1; });
        if (!matched.length) return null;
        var score = matched.length;
        /* Notele de bază persistă ore întregi — cântăresc mai mult decât cele
           de vârf, care dispar în 20 de minute. */
        matched.forEach(function (n) { if (p.notes && p.notes.base.indexOf(n) !== -1) score += 0.25; });
        return { p: p, matched: matched.map(noteLabel), score: score };
      }).filter(Boolean);
    } else if (AXES[s.mode]) {
      var field = AXES[s.mode].field;
      var lbl = function (v) { return self.axisLabel(s.mode, v); };
      picks = s.vals.map(lbl);
      scored = pool.map(function (p) {
        var matched = s.vals.filter(function (v) { return (p[field] || []).indexOf(v) !== -1; });
        if (!matched.length) return null;
        return { p: p, matched: matched.map(lbl), score: matched.length };
      }).filter(Boolean);
    } else if (s.mode === 'quiz') {
      var q = this.quizPicks();
      picks = q.stil.concat(q.util, q.fams).map(valLabel).concat(q.nota.map(noteLabel));
      scored = pool.map(function (p) {
        var matched = [];
        q.stil.forEach(function (v) { if (p.stil.indexOf(v) !== -1) matched.push(valLabel(v)); });
        q.util.forEach(function (v) { if (p.util.indexOf(v) !== -1) matched.push(valLabel(v)); });
        q.fams.forEach(function (v) { if (p.fams.indexOf(v) !== -1) matched.push(valLabel(v)); });
        q.nota.forEach(function (n) { if (p.all.indexOf(n) !== -1) matched.push(noteLabel(n)); });
        if (!matched.length) return null;
        return { p: p, matched: matched, score: matched.length };
      }).filter(Boolean);
    }

    scored.sort(function (a, b) { return b.score - a.score || a.p.price - b.p.price; });
    return { picks: picks, scored: scored, maxScore: scored.length ? scored[0].score : 1 };
  };

  /* Profilul olfactiv se citește din familiile primelor rezultate — merge la
     fel pentru toate drumurile, inclusiv cele care nu pornesc de la note. */
  P.buildProfile = function (scored) {
    var votes = {};
    scored.slice(0, 30).forEach(function (r) {
      r.p.fams.forEach(function (f) { votes[f] = (votes[f] || 0) + 1; });
    });
    var entries = Object.keys(votes).map(function (k) { return { label: valLabel(k), v: votes[k] }; })
      .sort(function (a, b) { return b.v - a.v; });
    var total = entries.reduce(function (s, e) { return s + e.v; }, 0) || 1;
    entries.forEach(function (e) { e.pct = Math.round(e.v / total * 100); });
    var headline = '';
    if (this.state.mode === 'ref' && this.state.ref) {
      headline = this.cfg.texts.refHeadline.replace('{parfum}', display.ref[this.state.ref] || titleCase(this.state.ref));
    } else if (entries.length) {
      headline = this.cfg.texts.profileHeadline.replace('{fam}', entries[0].label.toLowerCase());
      if (entries[1]) headline += ' ' + this.cfg.texts.profileAlso.replace('{fam}', entries[1].label.toLowerCase());
    }
    return { entries: entries.slice(0, 5), headline: headline };
  };

  /* ----- rezultate ----- */

  /* Genul a fost scos din pașii obligatorii, dar rămâne util aici: pe rezultate
     e o singură linie de pastile, nu un ecran care oprește pe toată lumea.
     Drumul „Gen" din pasul 1 rămâne pentru cine vrea să pornească de la el. */
  P.genderFilterHtml = function () {
    var gens = (this.cfg.genders || []).filter(function (g) { return g.collection; });
    if (gens.length < 2 || this.state.mode === 'gen') return '';
    var s = this.state;
    var t = this.cfg.texts;
    var pills = '<button type="button" class="ff__pill' + (s.gen ? '' : ' is-on') + '" data-ff="genfilter" data-key="">' +
      esc(t.genAll) + '</button>' +
      gens.map(function (g) {
        return '<button type="button" class="ff__pill' + (s.gen === g.key ? ' is-on' : '') + '" data-ff="genfilter" data-key="' + esc(g.key) + '">' +
          (g.emoji ? g.emoji + ' ' : '') + esc(g.label) + '</button>';
      }).join('');
    return '<div class="ff__pills"><span class="ff__pills-label">' + esc(t.genFilter) + '</span>' + pills + '</div>';
  };

  P.renderResults = function () {
    this.setProgress(3, this.cfg.stepLabels);
    var t = this.cfg.texts;
    var res = this.computeMatches();
    var profile = this.buildProfile(res.scored);
    this._lastResults = res;
    this.saveProfile({ headline: profile.headline });
    this.track('results', { mode: this.state.mode, picks: res.picks.length, found: res.scored.length });

    var prices = res.scored.map(function (r) { return r.p.price; });
    var lo = prices.length ? Math.floor(Math.min.apply(null, prices)) : 0;
    var hi = prices.length ? Math.ceil(Math.max.apply(null, prices)) : 100;
    if (this.state.priceMin == null) this.state.priceMin = lo;
    if (this.state.priceMax == null) this.state.priceMax = hi;

    var dna = profile.entries.map(function (e) {
      return '<div class="ff__dna-row"><span class="lbl">' + esc(e.label) + '</span>' +
        '<span class="bar"><i style="width:' + e.pct + '%"></i></span><span class="pct">' + e.pct + '%</span></div>';
    }).join('');

    this.stage.innerHTML =
      '<div class="ff__step">' +
      '<div class="ff__profile"><div class="ff__profile-title">' + esc(t.profileTitle) + '</div>' +
      '<div class="ff__profile-head">' + esc(profile.headline || t.resultsTitle) + '</div>' +
      '<div class="ff__dna">' + dna + '</div>' +
      '<div class="ff__profile-actions">' +
      '<button class="ff__btn ff__btn--ghost" data-ff="share">🔗 ' + esc(t.share) + '</button>' +
      '<button class="ff__btn ff__btn--ghost" data-ff="restart">↺ ' + esc(t.restart) + '</button>' +
      '</div></div>' +
      this.genderFilterHtml() +
      '<div class="ff__price"><span class="ff__price-label">' + esc(t.price) + '</span>' +
      '<div class="ff__price-range"><div class="ff__price-track"><i data-ff="ptrack"></i></div>' +
      '<input type="range" data-ff="rmin" min="' + lo + '" max="' + hi + '" value="' + this.state.priceMin + '" aria-label="Preț minim">' +
      '<input type="range" data-ff="rmax" min="' + lo + '" max="' + hi + '" value="' + this.state.priceMax + '" aria-label="Preț maxim"></div>' +
      '<div class="ff__price-inputs">' +
      '<label class="ff__price-field"><input type="number" data-ff="pmin" value="' + this.state.priceMin + '" min="' + lo + '" max="' + hi + '"><em>lei</em></label>' +
      '<span class="sep">–</span>' +
      '<label class="ff__price-field"><input type="number" data-ff="pmax" value="' + this.state.priceMax + '" min="' + lo + '" max="' + hi + '"><em>lei</em></label>' +
      '</div></div>' +
      '<div data-ff-groups></div>' +
      '<div class="ff__nav"><button class="ff__btn ff__btn--ghost" data-ff="back-refine">' + esc(t.refine) + '</button></div>' +
      '</div>';
    this.bind();
    this.bindPrice(lo, hi);
    this.renderGroups();
    this.syncUrl(true);
  };

  P.renderGroups = function () {
    var t = this.cfg.texts;
    var res = this._lastResults;
    var s = this.state;
    var wrap = this.stage.querySelector('[data-ff-groups]');
    var inPrice = function (r) { return r.p.price >= s.priceMin && r.p.price <= s.priceMax; };
    var visible = res.scored.filter(inPrice);

    if (!visible.length) {
      wrap.innerHTML = '<div class="ff__empty"><p>' + esc(t.empty) + '</p>' +
        '<button class="ff__btn ff__btn--primary" data-ff="restart">' + esc(t.tryAgain) + '</button></div>';
      this.bind(wrap);
      return;
    }

    function card(r) {
      var pct = Math.min(100, Math.round(r.score / Math.max(1, res.maxScore) * 100));
      var why = r.matched.slice(0, 3).map(function (m) { return '<span>' + esc(m) + '</span>'; }).join('');
      return '<div class="ff__item"><span class="ff__match' + (pct >= 75 ? ' hi' : '') + '">' + pct + '% ' + esc(t.match) + '</span>' +
        '<a href="' + esc(r.p.url) + '">' +
        (r.p.image ? '<img src="' + esc(r.p.image) + '" alt="" loading="lazy">' : '') +
        '<span class="ff__item-body"><span class="ff__item-vendor">' + esc(r.p.vendor) + '</span>' +
        '<span class="ff__item-title">' + esc(r.p.title) + '</span>' +
        '<span class="ff__why">' + why + '</span>' +
        '<span class="ff__item-price">' + money(r.p.price) + '</span></span></a></div>';
    }

    var html = '';
    if (s.mode === 'aroma' && res.picks.length > 1) {
      /* Pe mai multe note, cel mai util grup e „le are pe toate"; restul se
         împart pe note, ca omul să vadă la ce a renunțat. */
      var full = visible.filter(function (r) { return r.matched.length === res.picks.length; });
      var used = {};
      if (full.length) {
        full.forEach(function (r) { used[r.p.handle] = true; });
        html += '<div class="ff__group"><div class="ff__group-title">' + esc(t.groupAll) +
          ' <span class="chips">' + res.picks.map(function (n) { return '<span>' + esc(n) + '</span>'; }).join('') + '</span></div>' +
          '<div class="ff__group-sub">' + full.length + ' ' + esc(t.perfumes) + '</div>' +
          '<div class="ff__results">' + full.slice(0, 8).map(card).join('') + '</div></div>';
      }
      res.picks.forEach(function (n) {
        var group = visible.filter(function (r) { return !used[r.p.handle] && r.matched.indexOf(n) !== -1; });
        if (!group.length) return;
        group.slice(0, 8).forEach(function (r) { used[r.p.handle] = true; });
        html += '<div class="ff__group"><div class="ff__group-title">' + esc(t.groupWith) +
          ' <span class="chips"><span>' + esc(n) + '</span></span></div>' +
          '<div class="ff__group-sub">' + group.length + ' ' + esc(t.perfumes) + '</div>' +
          '<div class="ff__results">' + group.slice(0, 8).map(card).join('') + '</div></div>';
      });
    } else {
      var title = s.mode === 'ref'
        ? t.groupRef.replace('{parfum}', display.ref[s.ref] || titleCase(s.ref || ''))
        : t.groupBest;
      html = '<div class="ff__group"><div class="ff__group-title">' + esc(title) + '</div>' +
        '<div class="ff__group-sub">' + visible.length + ' ' + esc(t.perfumes) + '</div>' +
        '<div class="ff__results">' + visible.slice(0, 24).map(card).join('') + '</div></div>';
    }
    wrap.innerHTML = html;
  };

  P.bindPrice = function (lo, hi) {
    var self = this;
    var rmin = this.stage.querySelector('[data-ff="rmin"]');
    var rmax = this.stage.querySelector('[data-ff="rmax"]');
    var pmin = this.stage.querySelector('[data-ff="pmin"]');
    var pmax = this.stage.querySelector('[data-ff="pmax"]');
    var track = this.stage.querySelector('[data-ff="ptrack"]');
    if (!rmin) return;
    function paint() {
      var a = self.state.priceMin, b = self.state.priceMax;
      var span = Math.max(1, hi - lo);
      track.style.left = ((a - lo) / span * 100) + '%';
      track.style.width = ((b - a) / span * 100) + '%';
    }
    function apply(min, max, fromRange) {
      min = Math.max(lo, Math.min(isFinite(min) ? min : lo, hi));
      max = Math.max(lo, Math.min(isFinite(max) ? max : hi, hi));
      if (min > max) { var tmp = min; min = max; max = tmp; }
      self.state.priceMin = min;
      self.state.priceMax = max;
      pmin.value = min; pmax.value = max;
      if (fromRange !== 'min') rmin.value = min;
      if (fromRange !== 'max') rmax.value = max;
      paint();
      clearTimeout(self._priceT);
      self._priceT = setTimeout(function () { self.renderGroups(); self.syncUrl(true); }, 180);
    }
    rmin.addEventListener('input', function () { apply(parseFloat(rmin.value), self.state.priceMax, 'min'); });
    rmax.addEventListener('input', function () { apply(self.state.priceMin, parseFloat(rmax.value), 'max'); });
    pmin.addEventListener('change', function () { apply(parseFloat(pmin.value), self.state.priceMax); });
    pmax.addEventListener('change', function () { apply(self.state.priceMin, parseFloat(pmax.value)); });
    paint();
  };

  /* ----- evenimente ----- */

  P.resetPicks = function () {
    var s = this.state;
    s.notes = []; s.vals = []; s.ref = null; s.vibe = {};
    s.priceMin = null; s.priceMax = null;
  };

  P.bind = function (scope) {
    var self = this;
    var s = this.state;
    (scope || this.stage).querySelectorAll('[data-ff]').forEach(function (el) {
      if (el.dataset.ffBound) return;
      el.dataset.ffBound = '1';
      var kind = el.dataset.ff;

      if (kind === 'genfilter') el.addEventListener('click', function () {
        s.gen = el.dataset.key || null;
        /* Preț recalculat de la zero: intervalul vechi era al altui set de
           produse și ar fi putut ascunde tot ce a rămas. */
        s.priceMin = null; s.priceMax = null;
        self.track('gender', { gen: s.gen });
        self.syncUrl(true);
        self.renderResults();
      });

      if (kind === 'mode') el.addEventListener('click', function () {
        s.mode = el.dataset.key;
        self.resetPicks();
        self.track('mode', { mode: s.mode });
        self.syncUrl();
        self.route();
      });

      if (kind === 'ref-search') el.addEventListener('input', function () { self.refSuggest(el.value); });
      if (kind === 'note-search') el.addEventListener('input', function () { self.noteSuggest(el.value); });

      if (kind === 'ref-pick') el.addEventListener('click', function () {
        s.ref = el.dataset.key;
        self.track('ref', { ref: s.ref });
        self.syncUrl();
        self.route();
      });

      if (kind === 'note-pick') el.addEventListener('click', function () {
        var k = el.dataset.key;
        if (s.notes.indexOf(k) !== -1) return;
        if (s.notes.length >= self.maxNotes) { self.toast(self.cfg.texts.maxReached.replace('{max}', self.maxNotes)); return; }
        s.notes.push(k);
        self.refreshSelBar();
        var input = self.stage.querySelector('[data-ff="note-search"]');
        var box = self.stage.querySelector('[data-ff-ac]');
        if (input) { input.value = ''; input.focus(); }
        if (box) { box.hidden = true; box.innerHTML = ''; }
      });

      if (kind === 'val') el.addEventListener('click', function () {
        var k = el.dataset.key;
        var idx = s.vals.indexOf(k);
        if (idx !== -1) {
          s.vals.splice(idx, 1);
          el.classList.remove('is-selected');
        } else {
          if (s.vals.length >= self.maxVals) { self.toast(self.cfg.texts.axisMax.replace('{max}', self.maxVals)); return; }
          s.vals.push(k);
          el.classList.add('is-selected');
        }
        self.refreshValBar();
      });

      if (kind === 'vibe') el.addEventListener('click', function () {
        s.vibe[el.dataset.q] = el.dataset.key;
        self.track('vibe', { q: el.dataset.q, a: el.dataset.key });
        if (Object.keys(s.vibe).length === self.quiz.length) { self.syncUrl(); self.route(); }
        else self.renderQuizStep();
      });

      if (kind === 'surprise') el.addEventListener('click', function () {
        var counts = self.noteCounts();
        var pool = Object.keys(counts).filter(function (n) { return counts[n] >= 5; });
        s.notes = [];
        while (s.notes.length < Math.min(3, pool.length)) {
          var pick = pool[Math.floor(Math.random() * pool.length)];
          if (s.notes.indexOf(pick) === -1) s.notes.push(pick);
        }
        self.track('surprise', {});
        self.syncUrl();
        self.route();
      });

      if (kind === 'go-results') el.addEventListener('click', function () {
        self.syncUrl();
        self.route();
      });

      if (kind === 'back-mode') el.addEventListener('click', function () {
        s.mode = null;
        self.resetPicks();
        self.syncUrl();
        self.route();
      });
      if (kind === 'back-quiz') el.addEventListener('click', function () {
        var keys = Object.keys(s.vibe);
        if (keys.length) { delete s.vibe[self.quiz[keys.length - 1].key]; self.renderQuizStep(); }
        else { s.mode = null; self.syncUrl(); self.route(); }
      });
      if (kind === 'back-refine') el.addEventListener('click', function () {
        /* „Modifică alegerile" duce înapoi la ecranul drumului curent, cu
           selecțiile păstrate — mai puțin la quiz și la parfumul de referință,
           unde nu există altceva de modificat decât răspunsul însuși. */
        if (s.mode === 'quiz') s.vibe = {};
        if (s.mode === 'ref') s.ref = null;
        s.priceMin = null; s.priceMax = null;
        self.syncUrl();
        self.route();
      });

      if (kind === 'restart') el.addEventListener('click', function () {
        s.gen = null; s.mode = null;
        self.resetPicks();
        self.syncUrl();
        self.route();
      });

      if (kind === 'resume') el.addEventListener('click', function () {
        var saved = self.savedProfile();
        if (saved && saved.url) { history.pushState({ ff: 1 }, '', location.pathname + saved.url); self.restoreFromUrl(); }
      });

      if (kind === 'share') el.addEventListener('click', function () {
        var url = location.href;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () { self.toast(self.cfg.texts.shared); });
        } else { self.toast(url); }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-fragrance-finder]').forEach(function (el) {
      new FragranceFinder(el);
    });
  });
})();
